import { HttpParams } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService } from 'primeng/api';
import { NavMenuService } from 'src/app/components/core/components/navmenu/navmenu.service';
import { ComponentBase } from 'src/app/components/core/_infrastructure/classes/componentBase';
import { ExceptionManager } from 'src/app/components/core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from 'src/app/components/core/_infrastructure/classes/services/auth.service';
import { NotificationService } from 'src/app/components/core/_infrastructure/classes/services/notification.service';
import { TcPerfilUsuarioEnum } from 'src/app/components/core/_infrastructure/types/common';
import { EnumCodigosTwTcAcciones, EnumIdsTcTipoPuntoInspeccion, EnumIdsTwTcTipoClonacion } from '../../../_importacion/solicitudes/types/enum';
import { SolicitudExService } from '../datosbasicos/datosbasicosEx.service';
import { ProductosExService } from './productosEx.service';
import { EquipamientoExViewModel, SolicitudProductosExViewModel, TProductoSolicitudExViewModel, TwEmbalajesExViewModel } from './productosEx.types';
import { EnumIdsTwTcSubTipoSolicitudEx, EnumIdsTcEstadoSolicitudEx, EnumIdsTcTipoSolicitudEx } from '../types/enum';

@Component({
    selector: 'app-productosex-list',
    templateUrl: './productosEx-list.component.html',
})
export class ProductosSolicitudExListComponent extends ComponentBase implements OnInit {
    solicitudProductosEx: SolicitudProductosExViewModel;
    habilitarGuardar = false;
    habilitarNuevoProducto = false;
    //habilitarEdicion: boolean = true;
    numeroProductos = 0;
    numeroEmbalajes = 0;
    numeroBultosTotales = 0;
    EsPuerto = false;
    productoEditable: boolean;
    productoBorrable: boolean;
    matriculaBorrable: boolean;

    tercerPaisConAtestFito = EnumIdsTwTcSubTipoSolicitudEx.ID_TERCER_PAIS_CON_ATEST_FITO;
    reExpConAtestFito = EnumIdsTwTcSubTipoSolicitudEx.ID_REEXPORTACION_CON_ATEST_FITO;
    canariasConAtestFito = EnumIdsTwTcSubTipoSolicitudEx.ID_CANARIAS_CON_ATEST_FITO;
    deAtestacion = false;

    public isCollapsedGrid = false;
    public isCollapsedEquipamiento = false;
    public isCollapsedEmbalaje = false;
    public visibilityEmbalajes = false;
    visibilitySpinner = false;
    tituloTipoSolicitudEx: string;
    laHeGrabadoYo = false;
    esClonada = false;
    IdTipoSolicitudEx: number;
    idSolicitudEx: number;

    colsProds: any[];
    colsEmbs: any[];
    private matriculaLengthError = 'La longitud de cada matrícula no puede superar los 50 caracteres';

    constructor(
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private fb: UntypedFormBuilder,
        private navMenuService: NavMenuService,
        protected authService: AuthService,
        protected notificacionService: NotificationService,
        private confirmationService: ConfirmationService,
        protected exceptionHandler: ExceptionManager,
        private solicitudExService: SolicitudExService,
        private productosExService: ProductosExService,
    ) {
        super(authService, notificacionService, exceptionHandler);
        this.solicitudProductosEx = new SolicitudProductosExViewModel();
    }

    ngOnInit() {
        this.idSolicitudEx = +this.activatedRoute.snapshot.params['id'];

        this.guardRefreshPage(this.idSolicitudEx);

        this.createForm();

        if (this.idSolicitudEx) {
            //Para saber si se actua como Inspector o Grabador
            let params = new HttpParams();
            params = params.append('idSolicitudEx', this.idSolicitudEx.toString());
            params = params.append('idUsuario', this.loggedInUser!.Id.toString());
            this.solicitudExService.isSolicitudUsuario(params).subscribe(resultIsGrabada => {
                this.laHeGrabadoYo = resultIsGrabada;

                this.productosExService.getSolicitudProductosEx(this.idSolicitudEx).subscribe(result => {
                    this.solicitudProductosEx = result;
                    this.tituloTipoSolicitudEx = this.solicitudProductosEx.IdTipoSolicitudExDescripcion;
                    this.esClonada =
                        this.solicitudProductosEx.TwSolicitudJerarquiaEx != null &&
                        this.solicitudProductosEx.TwSolicitudJerarquiaEx.IdTipoClonacion == EnumIdsTwTcTipoClonacion.ID_CLONACION
                            ? true
                            : false;
                    this.IdTipoSolicitudEx = this.solicitudProductosEx.IdTipoSolicitudEx;

                    //SI ES PREVIA
                    if (this.solicitudProductosEx.EsPrevia) {
                        if (
                            this.solicitudProductosEx.IdEstadoSolicitudEx != EnumIdsTcEstadoSolicitudEx.ID_PREVIA_ACEPTADA &&
                            this.solicitudProductosEx.IdEstadoSolicitudEx != EnumIdsTcEstadoSolicitudEx.ID_PREVIA_PENDIENTE
                        ) {
                            this.tituloTipoSolicitudEx += '-Previa';
                        }
                    }

                    this.deAtestacion =
                        this.solicitudProductosEx.IdSubTipoSolicitudEx == this.tercerPaisConAtestFito ||
                        this.solicitudProductosEx.IdSubTipoSolicitudEx == this.reExpConAtestFito ||
                        this.solicitudProductosEx.IdSubTipoSolicitudEx == this.canariasConAtestFito;

                    //Si soy Inspector-Grabador
                    if (this.isGrabador && this.isInspector) {
                        this.habilitarGuardar =
                            this.loggedInUser!.getAction(
                                EnumCodigosTwTcAcciones.GUARDAR_EMBALAJES_EXPORTACION,
                                this.solicitudProductosEx.IdEstadoSolicitudEx,
                                undefined,
                            ).Visible && this.laHeGrabadoYo;
                        /*|| (this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.GUARDAR_INSPECCION, this.solicitudProductos.IdEstadoSolicitud).Visible)*/
                        this.habilitarNuevoProducto =
                            this.loggedInUser!.getAction(
                                EnumCodigosTwTcAcciones.GUARDAR_EMBALAJES_EXPORTACION,
                                this.solicitudProductosEx.IdEstadoSolicitudEx,
                                undefined,
                            ).Visible &&
                            this.laHeGrabadoYo &&
                            this.IdTipoSolicitudEx != EnumIdsTcTipoSolicitudEx.ID_CAMPANIAS_ESPECIFICAS;
                    } else {
                        this.habilitarGuardar = this.loggedInUser!.getAction(
                            EnumCodigosTwTcAcciones.GUARDAR_EMBALAJES_EXPORTACION,
                            this.solicitudProductosEx.IdEstadoSolicitudEx,
                            undefined,
                        ).Visible;
                        /*|| (this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.GUARDAR_INSPECCION, this.solicitudProductos.IdEstadoSolicitud).Visible)*/
                        this.habilitarNuevoProducto =
                            this.loggedInUser!.getAction(
                                EnumCodigosTwTcAcciones.GUARDAR_EMBALAJES_EXPORTACION,
                                this.solicitudProductosEx.IdEstadoSolicitudEx,
                                undefined,
                            ).Visible && this.IdTipoSolicitudEx != EnumIdsTcTipoSolicitudEx.ID_CAMPANIAS_ESPECIFICAS;
                    }

                    this.numeroProductos = this.solicitudProductosEx.TProductoSolicitudExCollection.length;
                    this.numeroEmbalajes = this.solicitudProductosEx.TwEmbalajesExCollection.length;

                    this.CalculoNumeroBultos();

                    //this.habilitarEdicion = this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.GUARDAR_SOLICITUD, this.solicitudProductos.IdEstadoSolicitud).Visible;
                    this.EsPuerto = this.solicitudProductosEx.TPuntoInspeccion.IdTipoPuntoInspeccion == EnumIdsTcTipoPuntoInspeccion.ID_PUERTO;
                    //metodo para deshabilitar los controles
                    this.DisableControlsConsulta();

                    this.updateForm();

                    this.productoEditable = this.checkEdit();
                    this.productoBorrable = this.checkDelete();
                    this.matriculaBorrable = this.checkDeleteMatricula();

                    if (!this.deAtestacion) {
                        //Cambios Productos
                        this.colsProds = [
                            { field: 'Link', header: '' },
                            {
                                field: 'Id',
                                header: 'Id',
                                display: 'none',
                            },
                            {
                                field: 'CodigoTaric',
                                header: 'Cód. Taric',
                            },
                            {
                                field: 'IdPaisDescripcion',
                                header: 'País Origen',
                            },
                            {
                                field: 'IdBotanicaDescripcion',
                                header: 'Nom Científico',
                            },
                            {
                                field: 'CodigoEppo',
                                header: 'Cód. EPPO',
                            },
                            {
                                field: 'NombreComun',
                                header: 'Nombre Común',
                            },
                            { field: 'Grupo', header: 'Grupo' },
                            {
                                field: 'IdFormaDescripcion',
                                header: 'Forma',
                            },
                            { field: 'Peso', header: 'Peso (Kg)' },
                            {
                                field: 'Unidades',
                                header: 'Unidades',
                            },
                            {
                                field: 'Volumen',
                                header: 'Volumen (m³)',
                            },
                            { field: 'NumeroBulto', header: 'Bultos' },
                        ];
                    } else {
                        //Cambios Productos
                        this.colsProds = [
                            { field: 'Link', header: '' },
                            {
                                field: 'Id',
                                header: 'Id',
                                display: 'none',
                            },
                            {
                                field: 'CodigoTaric',
                                header: 'Cód. Taric',
                            },
                            {
                                field: 'IdPaisDescripcion',
                                header: 'País Origen',
                            },
                            {
                                field: 'DeAtestacion',
                                header: 'De Atestación',
                            },
                            {
                                field: 'IdBotanicaDescripcion',
                                header: 'Nom Científico',
                            },
                            {
                                field: 'CodigoEppo',
                                header: 'Cód. EPPO',
                            },
                            {
                                field: 'NombreComun',
                                header: 'Nombre Común',
                            },
                            { field: 'Grupo', header: 'Grupo' },
                            {
                                field: 'IdFormaDescripcion',
                                header: 'Forma',
                            },
                            { field: 'Peso', header: 'Peso (Kg)' },
                            {
                                field: 'Unidades',
                                header: 'Unidades',
                            },
                            {
                                field: 'Volumen',
                                header: 'Volumen (m³)',
                            },
                            { field: 'NumeroBulto', header: 'Bultos' },
                        ];
                    }
                });
            });
        }

        //Contenedores, abrimos solo el primero
        this.isCollapsedGrid = false;
        this.isCollapsedEquipamiento = false;
        this.isCollapsedEmbalaje = false;

        //Cambios Embalajes
        this.colsEmbs = [
            { field: 'Link', header: '' },
            { field: 'Id', header: 'Id', display: 'none' },
            {
                field: 'IdTaricEmbalajeDescripcion',
                header: 'Material de Embalaje',
            },
            { field: 'IdEppoEmbalajeDescripcion', header: 'Cód. EPPO' },
            { field: 'Recuento', header: 'Recuento' },
            { field: 'IdUnidadEmbalajeDescripcion', header: 'Unidad' },
            { field: 'IdPaisEmbalajeDescripcion', header: 'País Origen' },
        ];
    }

    guardRefreshPage(id: number) {
        if ((id && !this.navMenuService.currentSolicitudExportacion.Id) || this.navMenuService.currentSolicitudExportacion.Id !== id) {
            this.solicitudExService.getSolicitudEx(id).subscribe(result => {
                this.navMenuService.currentSolicitudExportacion = result;
            });
        }
    }

    createForm() {
        this.form = this.fb.group({
            Matricula: '',
            //Observaciones: '',
            //IdNimf15: null
            //IdTipoEmbalaje: 0,
            //IdCodigoEppo: 0,
            //IdCodigoTaric: 0,
            //NumeroPaquetes: '',
        });
    }

    updateForm() {
        this.form.setValue({
            Matricula: '',
            //IdNimf15: this.solicitudProductos.IdNimf15 == null ? ''
            //    : this.solicitudProductos.IdNimf15 == EnumIdsTcNimf15.ID_CUMPLE ? '1'
            //        : this.solicitudProductos.IdNimf15 == EnumIdsTcNimf15.ID_NO_CUMPLE ? '2'
            //            : '3',
            //Observaciones: this.solicitudProductos.Observaciones
        });
    }

    private CalculoNumeroBultos() {
        this.numeroBultosTotales = 0;
        //recorro la coleccion para contar los bultos
        this.solicitudProductosEx.TwEmbalajesExCollection.forEach(y => {
            this.numeroBultosTotales += y.Recuento;
        });
    }

    private DisableControlsConsulta() {
        if (
            this.isInspector &&
            !this.laHeGrabadoYo &&
            this.solicitudProductosEx.IdEstadoSolicitudEx != EnumIdsTcEstadoSolicitudEx.ID_BORRADOR &&
            this.solicitudProductosEx.IdEstadoSolicitudEx != EnumIdsTcEstadoSolicitudEx.ID_REVISION_SOLICITANTE
        ) {
            this.form.controls['Matricula'].disable();
            this.visibilityEmbalajes = true;
            //if (!this.habilitarGuardar) {
            //this.form.controls['IdNimf15'].disable();
            //this.form.controls['Observaciones'].disable();
            //}
        } else {
            //this.form.controls['IdNimf15'].disable();
            //this.form.controls['Observaciones'].disable();

            if (!this.habilitarGuardar) {
                this.form.controls['Matricula'].disable();
            }
            //visibilidad Embalajes para solicitante, solo si debe ver alguna información
            //if (!(this.solicitudProductos.IdNimf15 == null && this.solicitudProductos.Observaciones == null)) {
            //    this.visibilityEmbalajes = true;
            //}
        }
    }

    checkEdit() {
        //Si soy Inspector-Grabador
        if (this.isGrabador && this.isInspector) {
            return (
                this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.GUARDAR_EMBALAJES_EXPORTACION, this.solicitudProductosEx.IdEstadoSolicitudEx, undefined)
                    .Visible && this.laHeGrabadoYo
            );
        } else {
            return this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.GUARDAR_EMBALAJES_EXPORTACION, this.solicitudProductosEx.IdEstadoSolicitudEx, undefined)
                .Visible;
        }
    }

    checkDelete() {
        //Si soy Inspector-Grabador
        if (this.isGrabador && this.isInspector) {
            return (
                this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.GUARDAR_EMBALAJES_EXPORTACION, this.solicitudProductosEx.IdEstadoSolicitudEx, undefined)
                    .Visible && this.laHeGrabadoYo
            );
        } else {
            return this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.GUARDAR_EMBALAJES_EXPORTACION, this.solicitudProductosEx.IdEstadoSolicitudEx, undefined)
                .Visible;
        }
    }

    checkDeleteMatricula() {
        //Si soy Inspector-Grabador
        if (this.isGrabador && this.isInspector) {
            return (
                this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.GUARDAR_EMBALAJES_EXPORTACION, this.solicitudProductosEx.IdEstadoSolicitudEx, undefined)
                    .Visible && this.laHeGrabadoYo
            );
        } else {
            return this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.GUARDAR_EMBALAJES_EXPORTACION, this.solicitudProductosEx.IdEstadoSolicitudEx, undefined)
                .Visible;
        }
    }

    onAdd() {
        this.router.navigate(['/exportacion/solicitud/productosEx/', this.solicitudProductosEx.Id, 'create']);
    }

    onEdit(item: SolicitudProductosExViewModel) {
        this.router.navigate(['/exportacion/solicitud/productosEx', this.solicitudProductosEx.Id, 'producto', item.Id]);
    }

    onDelete(item: TProductoSolicitudExViewModel) {
        this.confirmationService.confirm({
            message: '¿Está seguro?',
            accept: () => {
                //Actual logic to perform a confirmation
                this.productosExService.deleteSolicitudProductosEx(item.Id).subscribe(() => {
                    this.addSuccessMessage('Producto eliminado correctamente');
                    this.ngOnInit();
                });
            },
        });
    }

    onAddEmbalaje() {
        this.router.navigate(['/exportacion/solicitud/productosEx/', this.solicitudProductosEx.Id, 'create_packing']);
    }

    onEditEmbalaje(item: TwEmbalajesExViewModel) {
        this.router.navigate(['/exportacion/solicitud/productosEx', this.solicitudProductosEx.Id, 'embalaje', item.Id]);
    }

    onDeleteEmbalaje(item: TwEmbalajesExViewModel) {
        this.confirmationService.confirm({
            message: '¿Está seguro?',
            accept: () => {
                //Actual logic to perform a confirmation
                this.productosExService.deleteEmbalajeEx(item.Id).subscribe(() => {
                    this.addSuccessMessage('Embalaje eliminado correctamente');
                    this.ngOnInit();
                });
            },
        });
    }

    onAddMatricula() {
        //se podrán insertar varias separadas por comas (,)
        const matriculas = this.form.value.Matricula;
        const arrayMatriculas: string[] = matriculas.split(',');

        arrayMatriculas.forEach(x => {
            if (x != '') {
                const equipamiento = new EquipamientoExViewModel();
                const matricula = x.trim();
                if (matricula?.length > 50) {
                    this.addErrorMessage(this.matriculaLengthError + ' : ' + matricula);
                    return;
                }
                equipamiento.Matricula = matricula;
                this.solicitudProductosEx.TSolicitudEquipamientoExCollection.push(equipamiento);
            }
        });

        this.form.patchValue({
            Matricula: '',
        });
    }

    onDeleteMatricula(item: EquipamientoExViewModel) {
        this.solicitudProductosEx.TSolicitudEquipamientoExCollection.splice(this.solicitudProductosEx.TSolicitudEquipamientoExCollection.indexOf(item), 1);
    }

    guardarMatriculas() {
        this.confirmationService.confirm({
            message: '¿Está seguro de guardar las matrículas de la solicitud?',
            accept: () => {
                this.onSubmit();
            },
        });
    }

    onSubmit() {
        this.submitted = true;
        let numRepeticiones = 0;
        let errorMatriculas = false;

        if (
            !(
                this.isInspector &&
                !this.laHeGrabadoYo &&
                this.solicitudProductosEx.IdEstadoSolicitudEx != EnumIdsTcEstadoSolicitudEx.ID_BORRADOR &&
                this.solicitudProductosEx.IdEstadoSolicitudEx != EnumIdsTcEstadoSolicitudEx.ID_REVISION_SOLICITANTE
            )
        ) {
            //comprobar que no hay matriculas repetidas
            this.solicitudProductosEx.TSolicitudEquipamientoExCollection.forEach(x => {
                numRepeticiones = this.solicitudProductosEx.TSolicitudEquipamientoExCollection.filter(s => s.Matricula == x.Matricula).length;
                if (numRepeticiones > 1) {
                    errorMatriculas = true;
                }
            });

            if (errorMatriculas) {
                this.addErrorMessage('Hay matrículas repetidas en la lista de equipamientos');
                return;
            }
        }

        if (!this.form.valid) {
            return;
        }

        this.visibilitySpinner = true;

        const solicitudProductosEx = new SolicitudProductosExViewModel();

        solicitudProductosEx.TSolicitudEquipamientoExCollection = this.solicitudProductosEx.TSolicitudEquipamientoExCollection;
        solicitudProductosEx.Id = this.solicitudProductosEx.Id;

        if (
            !(
                this.isInspector &&
                !this.laHeGrabadoYo &&
                this.solicitudProductosEx.IdEstadoSolicitudEx != EnumIdsTcEstadoSolicitudEx.ID_BORRADOR &&
                this.solicitudProductosEx.IdEstadoSolicitudEx != EnumIdsTcEstadoSolicitudEx.ID_REVISION_SOLICITANTE
            )
        ) {
            this.productosExService.editSolicitudProductosEx(solicitudProductosEx).subscribe({
                next: () => {
                    this.addSuccessMessage('Matrículas guardadas correctamente');
                    this.router.navigate(['/exportacion/solicitud/productosEx/' + this.solicitudProductosEx.Id]);
                    //this.onBack();
                    this.visibilitySpinner = false;
                },
                error: error => {
                    this.catchServerError(error);
                    this.visibilitySpinner = false;
                },
            });
        }
    }

    onBack() {
        this.router.navigate(['/exportacion/solicitud/datosbasicosEx', this.solicitudProductosEx.Id]);
    }
}
